import makeStyles from '@mui/styles/makeStyles';
import {find} from 'lodash';
import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useLocation} from "react-router-dom";
import {loadCommunity} from "actions/supplementaryAction";
import logo from 'common/assets/logo-with-name.webp';
import {color, font, space, type} from "common/tokens";
import useFreshData, {dataKeys} from "common/useFreshData";
import CodeofConduct from "components/CodeofConduct";

const useStyles = makeStyles(theme => ({
  page: {
    background: color.SURFACE_MUTED,
    minHeight: '100%',
  },
  container: {
    width: '100%',
    maxWidth: space.CONTAINER_MAX,
    margin: '0 auto',
    padding: '32px 32px 64px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 28,
    [theme.breakpoints.down('md')]: {
      padding: '20px 16px 48px',
    },
  },
  logo: {
    width: 132,
    display: 'block',
  },
  back: {
    ...type.body,
    fontSize: 16,
    fontWeight: font.MEDIUM,
    color: color.TEXT_MUTED,
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    alignSelf: 'flex-start',
    cursor: 'pointer',
  },
}));

// These routes are reachable before signing in, so the page carries the logo
// home rather than the app bar, which is not rendered for a signed-out reader.
const PAGES = [
  {match: 'privacypolicy', id: 3, titleKey: 'privacyPolicy'},
  {match: 'codeofconduct', id: 6, titleKey: 'codeOfConduct'},
  {match: 'terms', id: 4, titleKey: 'termsOfService'},
];

const TermsAndConditions = () => {
  const classes = useStyles();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const history = useHistory();
  const community = useSelector(state => state.supplementary.community);

  useFreshData(dataKeys.COMMUNITY, () => dispatch(loadCommunity()));

  const path = pathname.toLowerCase().replace(/-/g, '');
  const page = find(PAGES, item => path.includes(item.match)) || PAGES[0];
  const content = find(community, item => item.id === page.id);

  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <button type={'button'} className={classes.back} onClick={() => history.goBack()}>
          {`← ${t('goBack')}`}
        </button>
        <Link to={'/'}>
          <img src={logo} className={classes.logo} alt={'Mentor To Go'}/>
        </Link>
        <CodeofConduct title={t(page.titleKey)} content={content}/>
      </div>
    </div>
  );
};

export default TermsAndConditions;
